<template>
  <header class="site-header">
    <div class="header-container">
      <div class="logo-container">
        <router-link to="/" class="logo">
          <div class="logo-wrapper">
            <img 
              :src="logoUrl" 
              alt="BullTire Logo" 
              class="logo-image"
              :class="{ loaded: logoLoaded }"
              @load="logoLoaded = true"
            />
          </div>
        </router-link>
      </div>

      <div class="nav-and-actions">
        <nav class="nav-menu">
          <ul class="nav-items">
            <li v-for="(item, index) in menuItems" :key="index" class="nav-item">
              <router-link :to="item.path" class="nav-link" :exact="item.exact">
                {{ item.label }}
              </router-link>
            </li>
          </ul>
        </nav>

        <div class="header-actions">
          <div class="language-selector">
            <button
              @click="changeLanguage('zh')"
              :class="['lang-btn', { active: currentLocale === 'zh' }]"
            >
              CN
            </button>
            <span class="lang-divider">/</span>
            <button
              @click="changeLanguage('en')"
              :class="['lang-btn', { active: currentLocale === 'en' }]"
            >
              EN
            </button>
          </div>

          <a :href="formattedJumpLink" target="_blank" class="contact-btn">{{$t('header.buyOnline')}}</a>
          <div class="tuhu-icon">
            <a :href="formattedJumpLink" target="_blank">
              <div class="tuhu-wrapper">
                <img 
                  :src="tuhuImageUrl" 
                  alt="Tuhu" 
                  class="tuhu-image"
                  :class="{ loaded: tuhuLoaded }"
                  @load="tuhuLoaded = true"
                />
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="mobile-menu-toggle" @click="toggleMobileMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <!-- 移动端弹出菜单 -->
      <div class="mobile-nav-menu" v-if="mobileMenuOpen">
        <div class="mobile-nav-logo">
          <img :src="logoUrl" alt="BullTire Logo" />
        </div>
        <ul>
          <li v-for="(item, index) in menuItems" :key="index" @click="closeMobileMenu">
            <router-link :to="item.path">{{ item.label }}</router-link>
          </li>
        </ul>
        <div class="mobile-lang">
          <button @click="changeLanguage('zh'); closeMobileMenu()" :class="['lang-btn', { active: currentLocale === 'zh' }]">CN</button>
          <button @click="changeLanguage('en'); closeMobileMenu()" :class="['lang-btn', { active: currentLocale === 'en' }]">EN</button>
        </div>

        <button class="mobile-menu-close" @click="closeMobileMenu">×</button>
      </div>
    </div>
  </header>
</template>

<script>
import { getHeaderInfo } from '@/api/home';

export default {
  name: 'SiteHeader',
  data() {
    return {
      currentLocale: this.$i18n.locale || 'zh',
      headerInfo: {
        officialWebsiteLogo: '',
        jumpLink: '',
        externalWarIcon: ''
      },
      logoLoaded: false,
      tuhuLoaded: false,
      mobileMenuOpen: false
    };
  },
  computed: {
    menuItems() {
      return [
        { label: this.$t('header.home'), path: '/', exact: true },
        { label: this.$t('header.product'), path: '/products', exact: false },
        { label: this.$t('header.about'), path: '/about', exact: false },
        { label: this.$t('header.blog'), path: '/blog', exact: false },
      ];
    },
    logoUrl() {
      return this.headerInfo.officialWebsiteLogo
        ? process.env.VUE_APP_IMAGE_URL + this.headerInfo.officialWebsiteLogo
        : '@/assets/images/logo.png';
    },
    tuhuImageUrl() {
      return this.headerInfo.externalWarIcon
        ? process.env.VUE_APP_IMAGE_URL + this.headerInfo.externalWarIcon
        : '@/assets/images/tuhu.jpg';
    },
    formattedJumpLink() {
      if (!this.headerInfo.jumpLink) return '#';
      return this.headerInfo.jumpLink.startsWith('http') 
        ? this.headerInfo.jumpLink 
        : `https://${this.headerInfo.jumpLink}`;
    }
  },
  created() {
    // 从 localStorage 初始化语言
    const savedLocale = localStorage.getItem('locale');
    if (savedLocale) {
      this.currentLocale = savedLocale;
      this.$i18n.locale = savedLocale;
    }
    this.fetchHeaderInfo();
  },
  methods: {
    changeLanguage(locale) {
      this.currentLocale = locale;
      this.$i18n.locale = locale;
      localStorage.setItem('locale', locale);
      this.$emit('language-changed', locale);
      this.$router.replace('/');
      window.location.reload();
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },
    async fetchHeaderInfo() {
      try {
        const response = await getHeaderInfo();
        if (response && response.data) {
          this.headerInfo = {
            officialWebsiteLogo: response.data.officialWebsiteLogo,
            jumpLink: response.data.jumpLink,
            externalWarIcon: response.data.externalWarIcon
          };
        }
      } catch (error) {
        console.error('Error fetching header info:', error);
      }
    }
  },
  watch: {
    mobileMenuOpen(val) {
      document.body.style.overflow = val ? 'hidden' : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color:#fff;
  backdrop-filter: blur(5px);
  z-index: 100;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-wrapper,
.tuhu-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  transition: opacity 0.3s ease;

  &.loaded {
    //.image-placeholder {
    //  opacity: 0;
    //}
    img {
      opacity: 1;
    }
  }
}

.logo-wrapper {
  height: 40px;
}
.logo-wrapper img {
  height: 40px;
}
.tuhu-wrapper {
  width: 50px;
  height: 50px;
  border-radius: 4px;
}

// 删除.image-placeholder相关内容
// 新增spinner样式
.image-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: transparent;
}
.spinner {
  width: 32px;
  height: 32px;
  border: 4px solid #eee;
  border-top: 4px solid #E00000;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}

.logo-image {
  opacity: 0;
  transition: opacity 0.3s;
}
.logo-image.loaded {
  opacity: 1;
}
.tuhu-image {
  opacity: 0;
  transition: opacity 0.3s ease;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.tuhu-image.loaded {
  opacity: 1;
}

.nav-and-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
}

.nav-menu {
  margin-right: 30px;
}

.nav-items {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  margin: 0 15px;
}

.nav-link {
  text-decoration: none;
  color: #050B20;
  font-size: 15px;
  font-weight: 500;
  position: relative;
  padding: 5px 0;
  text-transform: uppercase;

  &:hover {
    color: #E00000;
  }

  &.router-link-active:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #E00000;
  }
}

.header-actions {
  display: flex;
  align-items: center;
}

.language-selector {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.lang-btn {
  background: none;
  border: none;
  color: #808080;
  padding: 5px 3px;
  cursor: pointer;
  font-size: 14px;

  &.active {
    color:#050B20;
    font-weight: bold;
  }
}

.lang-divider {
  color: #050B20;
  margin: 0 3px;
}

.contact-btn {
  background-color: transparent;
  color: #E00000;
  border: 1px solid #E00000;
  border-radius: 50px;
  padding: 6px 18px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  margin-right: 15px;
  text-decoration: none;
  display: inline-block;

  &:hover {
    background-color: #E00000;
    color: white;
  }
}

.tuhu-icon {
  display: flex;
  align-items: center;
}

.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 24px;
  cursor: pointer;

  span {
    display: block;
    height: 2px;
    width: 100%;
    background-color: #fff;
    transition: all 0.3s;
  }
}

.mobile-nav-menu {
  display: none;
}

@media (max-width: 768px) {
  .header-container {
    padding: 10px 20px;
  }

  .nav-menu,
  .header-actions,
  .nav-and-actions {
    display: none !important;
  }
  .mobile-menu-toggle {
    display: flex;
    span {
      display: block;
      height: 5px;
      width: 100%;
      background-color: #E00000;
      margin-bottom: 5px;
      border-radius: 2px;
      transition: all 0.3s;
    }
  }
  .mobile-nav-menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255,255,255,0.98);
    z-index: 2000;
    padding-top: 40px;
    animation: fadeInMenu 0.3s;
    .mobile-nav-logo {
      width: 120px;
      margin: 0 auto 20px auto;
      img {
        width: 100%;
        display: block;
      }
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0 0 20px 0;
      width: 100%;
      li {
        margin: 12px 0;
        font-size: 22px;
        font-weight: bold;
        letter-spacing: 1px;
        text-align: center;
        a {
          color: #E00000;
          text-decoration: none;
          padding: 12px 40px;
          border-radius: 8px;
          display: inline-block;
          transition: background 0.2s;
        }
        a:active, a:hover {
          background: #ffeaea;
        }
      }
    }
    .mobile-lang {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
      button {
        background: none;
        border: none;
        color: #E00000;
        font-size: 20px;
        margin: 0 18px;
        font-weight: bold;
        border-radius: 6px;
        padding: 6px 18px;
        cursor: pointer;
        &.active {
          background: #E00000;
          color: #fff;
        }
      }
    }

    .mobile-menu-close {
      position: absolute;
      top: 18px;
      right: 18px;
      font-size: 40px;
      color: #E00000;
      background: none;
      border: none;
      width: 48px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      border-radius: 50%;
      transition: background 0.2s;
      cursor: pointer;
      font-weight: bold;
    }
    .mobile-menu-close:active, .mobile-menu-close:hover {
      background: #ffeaea;
    }
  }
}
@keyframes fadeInMenu {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
